// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_plus--solid"><path id="Union" d="M20.5 3C20.7761 3 21 3.22386 21 3.5V20.5C21 20.7761 20.7761 21 20.5 21H3.5C3.22386 21 3 20.7761 3 20.5V3.5C3 3.22386 3.22386 3 3.5 3H20.5ZM11 5V11H5V13H11V19H13V13H19V11H13V5H11Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_plus--line"><path id="Union" d="M13 11H21V13H13V21H11V13H3V11H11V3H13V11Z" style="fill: currentColor"/></g></svg>`;

export const Plus: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
